import { render, staticRenderFns } from "./AlertView.vue?vue&type=template&id=56d43f18&scoped=true"
import script from "./AlertView.vue?vue&type=script&lang=js"
export * from "./AlertView.vue?vue&type=script&lang=js"
import style0 from "./AlertView.vue?vue&type=style&index=0&id=56d43f18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d43f18",
  null
  
)

export default component.exports